import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { applyTheme } from './hooks/useTheme';

// Apply initial theme for Chinese Ink-Wash style
const THEME_KEY = 'nestmold-theme';
const MODE_KEY = 'nestmold-theme-mode';
const DAY_START = '07:00';
const DAY_END = '19:00';

function parseTime(value: string) {
  const parts = value.split(':');
  const h = Number(parts[0]);
  const m = Number(parts[1]);
  return h * 60 + m;
}

function minutesNow() {
  const d = new Date();
  return d.getHours() * 60 + d.getMinutes();
}

function isDayTime() {
  const now = minutesNow();
  return now >= parseTime(DAY_START) && now < parseTime(DAY_END);
}

const applyInitialTheme = () => {
  const mode = localStorage.getItem(MODE_KEY);
  const stored = localStorage.getItem(THEME_KEY);

  let theme: 'day' | 'night';
  if (mode === 'manual' && stored) {
    theme = stored as 'day' | 'night';
  } else {
    theme = isDayTime() ? 'day' : 'night';
  }

  applyTheme(theme);
};

applyInitialTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(<StrictMode><BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}><App /></BrowserRouter></StrictMode>);
